import { OrderUrlConstant } from 'src/constants';
import {
  CancelOrderDto,
  CreateOrderDto,
  GetOrderDto,
  GetOrderListDto,
  GetOrderListResponseDto,
  OrderDto,
} from 'src/dtos';
import { WithAuthToken, replacePlaceholders, httpRequest } from 'src/utils';

export class OrderApi {
  async create({ params, body, authToken }: WithAuthToken<CreateOrderDto>): Promise<OrderDto> {
    const { accountId } = params;
    const url = replacePlaceholders(OrderUrlConstant.CREATE, { accountId });

    return httpRequest<OrderDto>({
      method: 'POST',
      url,
      body,
      authToken,
    });
  }

  async list({ params, queryParams, authToken }: WithAuthToken<GetOrderListDto>): Promise<GetOrderListResponseDto> {
    const { accountId } = params;

    const url = replacePlaceholders(OrderUrlConstant.LIST, { accountId });

    return httpRequest<GetOrderListResponseDto>({
      method: 'GET',
      url,
      authToken,
      queryParams,
    });
  }

  async retrieve({ params, authToken }: WithAuthToken<GetOrderDto>): Promise<OrderDto> {
    const { id, accountId } = params;

    const url = replacePlaceholders(OrderUrlConstant.RETRIEVE, { id, accountId });

    return httpRequest<OrderDto>({
      method: 'GET',
      url,
      authToken,
    });
  }

  async cancel({ params, authToken }: WithAuthToken<CancelOrderDto>): Promise<void> {
    const { accountId, id } = params;

    const url = replacePlaceholders(OrderUrlConstant.CANCEL, { id, accountId });

    return httpRequest<void>({
      method: 'PUT',
      url,
      authToken,
    });
  }
}
